import React from 'react'
import {useDispatch} from 'react-redux'
import {MeasurementSystemType} from 'types/Localization'
import {getOfferDDActionName} from 'utils/getOfferDDActionName'
import {imageProvider} from 'utils/imageProvider'
import {WidgetLabelTypes} from 'utils/label'
import {SuggestionHotelCard} from 'widgets/components/HotelCarousel/HotelCard/SuggestionHotelCard'
import {
  getAnchorRate,
  getDisplayDiscount,
  getNightlyDisplayTotalPrice,
  getNumberOfNights,
  getRoundedNightlyDisplayTotalPrice
} from 'widgets/helpers/offer'

import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity
} from '@daedalus/core/src/analytics/types/Events'
import {TaxDisplayLogic} from '@daedalus/core/src/offer/types/TaxDisplayLogic'
import {getClosestDataIdToEventTarget} from '@daedalus/core/src/utils/dom'

import {Hotel} from '../../../../types/partnersApi/types'

interface HotelCardProps {
  hotel: Hotel
  checkIn?: string
  checkOut?: string
  numberOfRooms: number
  position: number
  taxDisplayLogic: TaxDisplayLogic
  currency: string
  partnerKey: string
  label?: string
  distanceUnit: MeasurementSystemType
}
export const HotelCard = ({
  hotel,
  checkIn,
  checkOut,
  taxDisplayLogic,
  currency,
  numberOfRooms,
  position,
  partnerKey,
  label,
  distanceUnit
}: HotelCardProps) => {
  const dispatch = useDispatch()

  if (!hotel?.details || !checkIn || !checkOut) {
    return null
  }

  const numberOfNights = getNumberOfNights(checkIn, checkOut)

  const {
    name,
    starRating,
    images,
    guestRating,
    reviewCount,
    vioUrl,
    distanceFromCityCentre,
    address
  } = hotel.details
  const {offers} = hotel
  const firstOffer = offers?.[0]

  const anchorRate = getAnchorRate(offers)

  const priceParameters = {
    rate: firstOffer?.rate,
    numberOfNights,
    numberOfRooms,
    taxDisplayLogic
  }

  const anchorPriceParameters = {
    rate: anchorRate,
    numberOfNights,
    numberOfRooms,
    taxDisplayLogic
  }

  const roundedPrice = getRoundedNightlyDisplayTotalPrice(priceParameters)

  const price = getNightlyDisplayTotalPrice(priceParameters) ?? 0

  const roundedAnchorPrice =
    anchorRate && getRoundedNightlyDisplayTotalPrice(anchorPriceParameters)
  const anchorPrice =
    (anchorRate && getNightlyDisplayTotalPrice(anchorPriceParameters)) ?? 0

  const savingPercentage = getDisplayDiscount(price, anchorPrice)

  const onHotelClick = (event: React.MouseEvent) => {
    event.stopPropagation()

    const selectedElementId = getClosestDataIdToEventTarget(event)

    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.Offer,
        action: Action.Clicked,
        payload: {
          partnerKey,
          widgetType: WidgetLabelTypes.multipleHotelsWithSearch,
          label,
          hotelPosition: position,
          selectedElementId
        }
      })
    )

    // We want to show cheapest offer price on card but still redirect to our SRP (to show all search results there)
    window.open(vioUrl, '_blank')
  }

  return (
    <SuggestionHotelCard
      imageProvider={imageProvider}
      key={hotel.id}
      hotelName={name}
      starRating={starRating}
      reviewRating={guestRating?.overall}
      imageUrl={images?.[0]}
      currency={currency}
      price={roundedPrice}
      reviewRatingCount={reviewCount}
      onHotelClick={onHotelClick}
      offerDDActionName={getOfferDDActionName(position)}
      distanceFromCityCentre={distanceFromCityCentre}
      distanceUnit={distanceUnit}
      address={address}
      savingPercentage={savingPercentage}
      anchorPrice={roundedAnchorPrice}
    />
  )
}
